import PillListContainer from './pillList'
export { PillListContainer as PillList }